angular.module('bmsApp.calendar').controller('CalendarCtrl', function ($scope,
																	   $window,
																	   $timeout,
																	   notify,
																	   uiCalendarConfig,
																	   CalendarSvc,
																	   ActivitySvc,
																	   MMJobPartSvc,
																	   SMScheduleSvc,
																	   TGVisitSvc,
																	   EmployeeHolidaySvc,
																	   TrainingRecordSvc,
																	   EmployeeSvc,
																	   EmployeeAttendanceRecordSvc,
																	   ConfigService) {

	let momentFormat = ConfigService.config.format.date.amDbDateTime;


	$scope.uiConfig = {
		calendar: {
			editable: false,
			selectable: true,
			eventOverlap: false,
			eventDurationEditable: false,
			contentHeight: 'auto',
			nextDayThreshold: '00:00:00',
			displayEventTime: false,
			select: function (start, end, jsEvent, view) {
				var dayDiff = end.diff(start, 'days');
				var startClone = moment(start.toDate());
				// if just 1 day is selected make the end date the same
				var endClone = dayDiff == 1 ? startClone.clone() : moment(end.toDate());
				startClone.set({
					hour: 9,
					minute: 0,
					second: 0
				});
				endClone.set({
					hour: 10,
					minute: 0,
					second: 0
				});

				var foo = moment.utc('2016-10-18 09:00:00');

				event = {
					reoccurence_type: 'Does not repeat',
					activity_start_date: startClone,
					activity_end_date: endClone
				};
				ActivitySvc.showSaveModal(event)
					.then(function (result) {
						if (result.success === true) {
							$scope.updateFilters();
						}
					});
			},
			eventRender: function (event, element) {
				element.find('.fc-title').html(event.title);
				let proximityDistance = parseInt($scope.form.proximity.value) || 10000;
				if (angular.isObject(event.visit) && proximityDistance !== -1) {
					console.log(event.visit.distance_from_filter, proximityDistance);
					if (event.visit.distance_from_filter > proximityDistance) {
						element.find('.fc-title').parent().parent()
							.css('opacity', 0.3);
					}
				}
			},
			eventClick: function (event, jsEvent, view) {
				if (event.type === 'activity') {
					loadEvent(event);
				} else if (event.type === 'serviceMaster') {
					loadServiceMasterEvent(event);
				}
			},
			eventDrop: function (event, delta, revertFunc, jsEvent, ui, view) {
				if (event.type === 'activity') {
					event.activity_start_date = event.start.clone().format();
					event.activity_end_date = event.end.clone().format();
					ActivitySvc.showSaveModal(event.activity)
						.then(function (result) {
							if (result.success === true) {
								$scope.updateFilters();
							}
							else {
								revertFunc();
							}
						}, function () {
							revertFunc();
						});
				}
			},
			eventResize: function (event, delta, revertFunc, jsEvent, ui, view) {
				if (event.type === 'activity') {
					event.activity_start_date = event.start.clone().format();
					event.activity_end_date = event.end.clone().format();
					ActivitySvc.showSaveModal(event)
						.then(function (result) {
							if (result.success === true) {
								$scope.updateFilters();
							}
							else {
								revertFunc();
							}
						}, function () {
							revertFunc();
						});
				}
			},
			eventMouseover: function (event, jsEvent, view) {

			},
			eventOrder: ['order', 'title'],
			header: {
				left: 'prev,next today',
				center: 'title',
				right: 'month,agendaWeek,agendaDay'
			},
			lang: 'en-GB'
		}
	};

	$scope.options = {
		proximity: [
			{
				label: 'Anywhere',
				value: -1,
			},
			{
				label: '1 mile',
				value: 1,
			},
			{
				label: '2 miles',
				value: 2,
			},
			{
				label: '3 miles',
				value: 3,
			},
			{
				label: '5 miles',
				value: 5,
			},
			{
				label: '10 miles',
				value: 10,
			},
		]
	};

	$scope.form = {
		distance_postcode: '',
		proximity: $scope.options.proximity[0]
	};


	function loadEvent(event) {
		$scope.selectedEvent = event.activity;
		$scope.selectedType = 'activity';
		$scope.eventVisible = true;
	}

	function loadServiceMasterEvent(event) {
		$scope.selectedEvent = event.serviceMaster;
		$scope.selectedType = 'serviceMaster';
		$scope.eventVisible = true;
	}

	$scope.editActivity = function(event) {
		ActivitySvc.showSaveModal(event)
			.then(function (result) {
				$scope.selectedEvent = result.activity;
				if (result.success === true) {
					$scope.updateFilters();
				}
			});
	};

	$scope.addNewActivity = function(event) {
		event = {
			reoccurence_type: 'Does not repeat',
			activity_start_date: null,
			activity_end_date: null
		};

		ActivitySvc.showSaveModal(event)
			.then(function (result) {
				if (result.success === true) {
					$scope.updateFilters();
				}
			});
	};

	$scope.closeEventPanel = function() {
		$scope.eventVisible = false;
	};

	$scope.ctrl = {
		activeFilters: {
			categories: {
				bank_holidays: true,
				crm: false,
				work: false,
				holidays: false,
				training: false,
				sickness: false,
				car: false
			}
		}
	};

	$scope.allEventSources = {
		bank_holidays: {
			active: true,
			eventSource: {
				events: function (start, end, timezone, callback) {
					var config = {
						params: {
							start: start.format(momentFormat),
							end: end.format(momentFormat)
						}
					};
					CalendarSvc.bankHolidays(config.params)
						.then(function (response) {
							events = response.data.events;
							callback(events);
						}, function () {
							console.log('Failed to load bank holidays');
						});
				},
				editable: false,
				overlap: true
			}
		},
		crm: {
			active: false,
			eventSource: {
				events: function (start, end, timezone, callback) {
					var config = {
						params: {
							start: start.format(momentFormat),
							end: end.format(momentFormat)
						}
					};
					ActivitySvc.calendarEvents(config.params)
						.then(function (response) {
							events = response.data.events;
							callback(events);
						}, function () {
							console.log('Failed to load activity events');
						});
				},
				editable: true,
				overlap: true
			}
		},
		anniversaries: {
			active: false,
			eventSource: {
				events: function (start, end, timezone, callback) {
					var config = {
						params: {
							start: start.format(momentFormat),
							end: end.format(momentFormat)
						}
					};
					CalendarSvc.allAnniversaries(config.params)
						.then(function (response) {
							events = response.data.events;
							callback(events);
						}, function () {
							console.log('Failed to load anniversary events');
						});
				},
				editable: true,
				overlap: true
			}
		},
		work: {
			active: false,
			eventSource: {
				events: function (start, end, timezone, callback) {
					var config = {
						params: {
							start: start.format(momentFormat),
							end: end.format(momentFormat),
							proximity: $scope.form.proximity.value,
							postcode: $scope.form.distance_postcode,
						}
					};
					if ($scope.isMM()) {
						MMJobPartSvc.calendarEvents(config.params)
							.then(function (response) {
								events = response.data.events;
								callback(events);
							}, function (errors) {
								notify({
									message: errors[0],
								});
							});
					}
					if ($scope.isTG()) {
						TGVisitSvc.calendarEvents(config.params)
							.then(function (response) {
								events = response.data.events;
								callback(events);
							}, function (errors) {
								notify({
									message: errors[0],
								});
							});
					}
					if ($scope.isSM()) {
						SMScheduleSvc.calendarEvents(config.params)
							.then(function (response) {
								events = response.data.events;
								callback(events);
							}, function (errors) {
								notify({
									message: errors[0],
								});
							});
					}
				}
			}
		},
		holidays: {
			active: false,
			eventSource: {
				events: function (start, end, timezone, callback) {
					var config = {
						params: {
							start: start.format(momentFormat),
							end: end.format(momentFormat),
							activeEmployee: true
						}
					};
					EmployeeHolidaySvc.allEmployeesCalendar(config.params)
						.then(function (response) {
							events = response.data.employee_holidays;
							callback(events);
						}, function () {
							console.log('Failed to load employee holidays calendar');
						});
				}
			}
		},
		training: {
			active: false,
			eventSource: {
				events: function (start, end, timezone, callback) {
					var config = {
						params: {
							start: start.format(momentFormat),
							end: end.format(momentFormat)
						}
					};
					TrainingRecordSvc.calendarEvents(config.params)
						.then(function (response) {
							events = response.data.events;
							callback(events);
						}, function () {
							console.log('Failed to load employee training events');
						});
				}
			}
		},
		nonAttendance: {
			active: false,
			eventSource: {
				events: function (start, end, timezone, callback) {
					var config = {
						params: {
							start: start.format(momentFormat),
							end: end.format(momentFormat)
						}
					};
					EmployeeAttendanceRecordSvc.nonAttendanceCalendarEvents(config.params)
						.then(function (response) {
							events = response.data.events;
							callback(events);
						}, function () {
							console.log('Failed to load non-attendance events');
						});
				}
			}
		},
		car: {
			active: false,
			eventSource: {
				events: function (start, end, timezone, callback) {
					var config = {
						params: {
							start: start.format(momentFormat),
							end: end.format(momentFormat)
						}
					};
					EmployeeSvc.carCalendarEvents(config.params)
						.then(function (response) {
							events = response.data.events;
							callback(events);
						}, function () {
							console.log('Failed to load car events');
						});
				}
			}
		},
		serviceMaster: {
			active: false,
			eventSource: {
				events: function (start, end, timezone, callback) {
					var config = {
						params: {
							start: start.format(momentFormat),
							end: end.format(momentFormat)
						}
					};
					CalendarSvc.serviceMaster(config.params)
						.then(function (response) {
							events = response.data.events;
							callback(events);
						}, function () {
							console.log('Failed to load service master events');
						});
				},
				editable: false,
				overlap: true
			}
		},
	};

	$scope.applyEventSourceFilters = function () {
		$scope.allEventSources.crm.active = angular.isDefined($window.localStorage['calendar_filter_crm']) ? JSON.parse($window.localStorage['calendar_filter_crm']) : true;
		$scope.allEventSources.work.active = angular.isDefined($window.localStorage['calendar_filter_work']) ? JSON.parse($window.localStorage['calendar_filter_work']) : false;
		$scope.allEventSources.holidays.active = angular.isDefined($window.localStorage['calendar_filter_holidays']) ? JSON.parse($window.localStorage['calendar_filter_holidays']) : false;
		$scope.allEventSources.training.active = angular.isDefined($window.localStorage['calendar_filter_training']) ? JSON.parse($window.localStorage['calendar_filter_training']) : false;
		$scope.allEventSources.nonAttendance.active = angular.isDefined($window.localStorage['calendar_filter_non_attendance']) ? JSON.parse($window.localStorage['calendar_filter_non_attendance']) : false;
		$scope.allEventSources.car.active = angular.isDefined($window.localStorage['calendar_filter_car']) ? JSON.parse($window.localStorage['calendar_filter_car']) : false;
		$scope.allEventSources.serviceMaster.active = angular.isDefined($window.localStorage['calendar_filter_service_master']) ? JSON.parse($window.localStorage['calendar_filter_service_master']) : false;
		$scope.allEventSources.anniversaries.active = angular.isDefined($window.localStorage['calendar_filter_anniversaries']) ? JSON.parse($window.localStorage['calendar_filter_anniversaries']) : false;
		$timeout(function () {
			$scope.updateFilters();
		});
	};

	$scope.syncEventSourceFilters = function () {
		$window.localStorage['calendar_filter_crm'] = JSON.stringify($scope.allEventSources.crm.active);
		$window.localStorage['calendar_filter_work'] = JSON.stringify($scope.allEventSources.work.active);
		$window.localStorage['calendar_filter_holidays'] = JSON.stringify($scope.allEventSources.holidays.active);
		$window.localStorage['calendar_filter_training'] = JSON.stringify($scope.allEventSources.training.active);
		$window.localStorage['calendar_filter_non_attendance'] = JSON.stringify($scope.allEventSources.nonAttendance.active);
		$window.localStorage['calendar_filter_car'] = JSON.stringify($scope.allEventSources.car.active);
		$window.localStorage['calendar_filter_service_master'] = JSON.stringify($scope.allEventSources.serviceMaster.active);
		$window.localStorage['calendar_filter_anniversaries'] = JSON.stringify($scope.allEventSources.anniversaries.active);
	};

	$scope.eventSources = [];
	$scope.updateFilters = function () {
		// remove all event sources
		angular.forEach($scope.allEventSources, function (value) {
			uiCalendarConfig.calendars['breakout'].fullCalendar('removeEventSource', value.eventSource);
		});
		// (re-)add the selected event sources
		angular.forEach($scope.allEventSources, function (value) {
			if (value.active === true) {
				uiCalendarConfig.calendars['breakout'].fullCalendar('addEventSource', value.eventSource);
			}
		});
		//uiCalendarConfig.calendars['breakout'].fullCalendar('refetchEvents');
		$scope.syncEventSourceFilters();
	};

	$scope.applyEventSourceFilters();

});
